import React from "react";

export default function IconSortDirectionDesc({ size = 20, ...rest }) {
  return (
    <svg width={size} height={size} {...rest} viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <g id="Icon">
        <path id="Vector" d="M7.35321 12.7391L4.94962 10.4783C4.65688 10.2029 4.59155 9.88783 4.75364 9.53304C4.91511 9.17768 5.20385 9 5.61985 9H10.3808C10.7968 9 11.0855 9.17768 11.247 9.53304C11.4091 9.88783 11.3438 10.2029 11.051 10.4783L8.64744 12.7391C8.555 12.8261 8.45485 12.8913 8.347 12.9348C8.23914 12.9783 8.12359 13 8.00033 13C7.87706 13 7.76151 12.9783 7.65365 12.9348C7.5458 12.8913 7.44565 12.8261 7.35321 12.7391Z" fill="currentColor" />
      </g>
    </svg>
  );
};